import HomePage from "../Components/HomePage";

function Home() {
    return (
        <HomePage />
    );
}

export default Home;